import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { RegistrationsServiceProxy, RegistrationDto, TransferRegistrationDto, EventsServiceProxy, EntityDtoOfInt64, TransferRegistrationAnotherEventDto, } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'transferToAnotherEventModal',
    templateUrl: './transfer-to-another-event-modal.component.html'
})

export class  TransferToAnotherEventModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal') modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    registration: RegistrationDto = new RegistrationDto();
    event = undefined;
    categoryDeadLineId = undefined;

    events = [];
    categoriesDeadline = [];

    constructor(
        injector: Injector,
        private _registrationsService: RegistrationsServiceProxy,
        private _eventsService: EventsServiceProxy
    ) {
        super(injector);
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();
    }

    public show(registration: RegistrationDto): void {

        this.initialize();
        this.active = true;
        this.registration = registration;
        this.modal.show();
    }

    initialize(): void {
        this.event = undefined;
        this.categoryDeadLineId = undefined;
        this.events = [];
        this.categoriesDeadline = [];
    }

    save(): void {

        let msg = this.l('Are you sure transfer to another event the registration of the {0}?', this.registration.user.name);
        msg += ' ' + this.l('If necessary, you can generate a payment charge in Payables or Receivables to balance the Cash Flow.');

        let inputTransfer = new TransferRegistrationAnotherEventDto();
        inputTransfer.registrationId = this.registration.id;
        inputTransfer.eventId = this.event.id;
        inputTransfer.categoryDeadLineId = this.categoryDeadLineId;

        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {
                this._registrationsService.transferToAnotherEvent(inputTransfer)
                    .subscribe(() => {
                    this.notify.info(this.l('SavedSuccessfully'));
                    this.close();
                    this.modalSave.emit(null);
                    });
                }
            }
        );
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService.getEventsForSelect(event.query, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
            this.events = result.items;
        });
    }

    // Load Categories Event
    loadCategoriesEvent(checkIsSelected?: boolean): void {

        if (this.event && this.event.id && this.categoriesDeadline.length > 0 && this.categoriesDeadline.filter(x => x.eventId == this.event.id).length > 0) {
            return null;
        }
        else{

        this.categoriesDeadline = [];
        this.categoryDeadLineId = undefined;

        if(this.event && this.event.id) {
          this._eventsService.getCategoryDeadlines(undefined, this.event.id, false)
            .subscribe(result => {
                this.categoriesDeadline = result.items;
            });
        }
    }

    }
}



// WEBPACK FOOTER //
// ./src/app/event/registrations/modals/transfer-to-another-event/transfer-to-another-event-modal.component.ts